import { UI_Link } from 'ui/components/1-atoms/Action/Link/Link';
import styles from './Breadcrumb.module.scss';
import classNames from 'classnames';
import House from 'ui/icons/House.svg';

export interface BreadcrumbProps {
	breadcrumbItems: Array<BreadcrumbItemProps>;
}

interface BreadcrumbItemProps {
	url?: string;
	title: string;
}

export const UI_Breadcrumb = ({ breadcrumbItems }: BreadcrumbProps) => (
	<ul className={styles.Breadcrumb}>
		{breadcrumbItems.map((breadcrumbItem: BreadcrumbItemProps, index) => (
			<li key={index} className={styles.Breadcrumb_item}>
				{breadcrumbItem.url && index !== breadcrumbItems.length - 1 ? (
					index === 0 ? (
						<UI_Link
							showIcon
							icon={<House />}
							iconStyle="none"
							iconSize="sm"
							url={breadcrumbItem.url}
							className={styles.Breadcrumb_url}
							ariaLabel={breadcrumbItem.title}
							{...breadcrumbItem}
						></UI_Link>
					) : (
						<UI_Link url={breadcrumbItem.url} className={styles.Breadcrumb_url} {...breadcrumbItem}>
							{breadcrumbItem.title}
						</UI_Link>
					)
				) : (
					<p className={classNames(styles.Breadcrumb_url, styles.Breadcrumb_url___current)}>{breadcrumbItem.title}</p>
				)}
			</li>
		))}
	</ul>
);
